/* eslint-disable */
// src/services/localMachineCounterConfigService.js

import axios from "services/axiosConfig";

const API_URL = "/api/local-machine-counter-config";

class LocalMachineCounterConfigService {
  static async getActiveLocalMachineCounterConfig(localMachineId) {
    try {
      const response = await axios.get(`${API_URL}/local-machine/${localMachineId}/active`);
      return response.data || null;
    } catch (error) {
      console.error("Error al obtener la configuración activa de contadores:", error);
      return null;
    }
  }

  static async getLocalMachineCounterConfigHistory(localMachineId) {
    try {
      const response = await axios.get(`${API_URL}/local-machine/${localMachineId}/history`);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error al obtener el historial de configuraciones de contadores:", error);
      return [];
    }
  }

  static async getLocalMachineCounterConfigDateBounds(localMachineId) {
    try {
      const response = await axios.get(`${API_URL}/local-machine/${localMachineId}/date-bounds`);
      return response.data || null;
    } catch (error) {
      console.error("Error al obtener limites de fecha para contadores:", error);
      throw error;
    }
  }

  static async getCounterInitialValuesStatusByLocal(localId) {
    try {
      const response = await axios.get(`${API_URL}/local/${localId}/initial-values-status`);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error al obtener estado de valores iniciales de contadores:", error);
      throw error;
    }
  }

  static async updateCounterInitialValues(configId, payload = {}) {
    try {
      const response = await axios.patch(`${API_URL}/${configId}/initial-values`, {
        InitialCounterIn: payload.InitialCounterIn,
        InitialCounterOut: payload.InitialCounterOut,
      });
      return response.data || null;
    } catch (error) {
      console.error("Error al actualizar valores iniciales de contadores:", error);
      throw error;
    }
  }

  static async createLocalMachineCounterConfig(payload = {}) {
    try {
      const requestPayload = {
        LocalMachineId: payload.LocalMachineId,
        CounterInFormulaId: payload.CounterInFormulaId,
        CounterOutFormulaId: payload.CounterOutFormulaId,
        CounterInFormula: payload.CounterInFormula,
        CounterOutFormula: payload.CounterOutFormula,
        ToleranceAmount: payload.ToleranceAmount,
      };

      if (payload.InitialCounterIn !== undefined) {
        requestPayload.InitialCounterIn = payload.InitialCounterIn;
      }
      if (payload.InitialCounterOut !== undefined) {
        requestPayload.InitialCounterOut = payload.InitialCounterOut;
      }

      if (payload.EffectiveDate) requestPayload.EffectiveDate = payload.EffectiveDate;
      else if (payload.StartDateTime) requestPayload.StartDateTime = payload.StartDateTime;

      const response = await axios.post(API_URL, requestPayload);
      return response.data;
    } catch (error) {
      console.error("Error al crear la configuración de contadores:", error);
      throw error;
    }
  }

  static async removeActiveCounterConfigFromLocalMachine(localMachineId, payload = {}) {
    try {
      const response = await axios.patch(
        `${API_URL}/local-machine/${localMachineId}/remove-active`,
        { EffectiveDate: payload.EffectiveDate }
      );
      return response.data;
    } catch (error) {
      console.error("Error al quitar la configuración activa de contadores:", error);
      throw error;
    }
  }

  static async deactivateLocalMachineCounterConfig(id, payload = {}) {
    try {
      const response = await axios.delete(`${API_URL}/${id}`, { data: payload });
      return response.data || null;
    } catch (error) {
      console.error("Error al desactivar la configuración de contadores:", error);
      throw error;
    }
  }
}

export default LocalMachineCounterConfigService;
